import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type Props = {
  children: ReactNode;
  className?: string;
};

export function MobileScreen({ children, className }: Props) {
  return (
    <div
      className={cn(
        "mobile-screen flex h-full min-h-0 flex-col bg-[var(--mail-bg)] text-[var(--mail-text)]",
        className
      )}
    >
      {children}
    </div>
  );
}
